module.exports = __webpack_public_path__ + "assets/icon_product_maintenance.b0543fb8.svg";